import { Dispatch } from 'redux'
import { TypedUseSelectorHook, useDispatch, useSelector, shallowEqual } from 'react-redux'

import store, { persistor, RootState } from './store'

export * from '@redux/store/index'
export * from '@redux/types'

export type AppDispatch = Dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export { shallowEqual }

export { store, persistor }
